import EditVerifiedPurchase from './components/EditVerifiedPurchase';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import values from 'lodash/values';
import { connect } from 'react-redux';

import {
  createReceiptLineup,
  updateReceiptLineup,
  loadReceiptLineups,
  loadGiftCards,
  loadCampaignsForAgency
} from '../../shared/redux/entities/actions';
import './EditVerifiedPurchase.css'
// import { getBrandsWithKPIs } from '../../shared/redux/selectors'
import has from "lodash/has";

function mapStateToProps(state,props){
  const receiptId = props.match.params.receiptId,
      brandId = props.brandId;
  // const brands = getBrandsWithKPIs(state).filter((b) => b.agencyId === props.accountId)
  return {
    brandId:brandId,
    receiptId:receiptId,
    needsLoading:!has(state,['entities','agencies',brandId,'name']),
    isCreate:receiptId === 'new',
    agencyId:get(state,['entities','companies',brandId,'agencyId']),
    receipt:get(state,['entities','receiptLineups',receiptId], null),
    campaigns:values(get(state,['entities','campaigns'], {})).filter((c) => c.companyId === brandId),
    giftCards:values(get(state,['entities','giftcards'], {}))
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createReceiptLineup,
    updateReceiptLineup,
    loadReceiptLineups,
    loadGiftCards,
    loadCampaignsForAgency
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditVerifiedPurchase));



// WEBPACK FOOTER //
// ./src/routes/EditVerifiedPurchase/index.js